import type { CSSProperties } from 'react';

export const REPORTS_INPUT: CSSProperties = {
    width: '100%',
    height: 38,
    padding: '0 12px',
    borderRadius: 10,
    border: '1.5px solid var(--cpm-border-strong)',
    fontSize: 13,
    fontWeight: 600,
    color: 'var(--cpm-text-primary)',
    background: '#fff',
};

export const REPORTS_KICKER: CSSProperties = {
    margin: 0,
    fontSize: 9.5,
    fontWeight: 800,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--cpm-text-tertiary)',
};

export const REPORTS_TITLE: CSSProperties = {
    margin: 0,
    fontSize: 20,
    fontWeight: 800,
    letterSpacing: '-0.02em',
    color: 'var(--cpm-text-primary)',
};

export const REPORTS_SAVED_BANNER: CSSProperties = {
    margin: 0,
    padding: '8px 12px',
    borderRadius: 8,
    background: 'var(--cpm-success-bg)',
    color: 'var(--cpm-success-text)',
    fontWeight: 800,
    fontSize: 13,
};
